/* Style Imports */
import styled from 'styled-components';

// Base Highlight
export const Highlight = styled.span`
    color: var(--highlight-color);
    font-weight: bold;
`;

// Featured Work Highlight
export const FWHighlight = styled(Highlight)`
`;

// Short Intro Highlight
export const SIHighlight = styled(Highlight)`
`;